import { useEffect, useState } from 'react'
import { useRadiologyOrders } from './UseRadiologyOrders'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import {
  selectLocationById,
  selectSelectedLocationId,
} from '../../../location/locationSlice'
import { startSxpProxy } from '../../../../utils/api'
import { OPD_PROJECT_ID } from '../../../../utils/constants'
import { DomainResource } from 'fhir/r4'
import { formatPatientVisits } from '../../../lms/utils'
import { PatientVisit } from '../../../lms/models'
import PatientVisitsTable from '../../../lms/components/search/PatientVisitsTable'
import RadiologySearchTable from './RadiologySearchTable'
import {
  emptyString,
  radiologyIntents,
  radiologyTestStatus,
  radiologyText,
  tabs,
} from '../../Constants/constants'
import { RadiologyOrders } from '../../models'
import { setRadiologyActiveTab } from '../../RadiologySlice'
import { radiologyEndPoint } from '../../RadiologyEndPoints'

type Props = {
  id: string
  onView: (url: string) => void
  onCreate: (id: string) => void
}

const AllRadiologyOrders = ({ id, onView, onCreate }: Props) => {
  const locationId = useAppSelector(selectSelectedLocationId)
  const dispatch = useAppDispatch()
  const location = useAppSelector((state) =>
    selectLocationById(locationId, state)
  )
  const orders = useRadiologyOrders(id, location?.resource?.name ?? emptyString)
  const [visits, setVisits] = useState<PatientVisit[]>([])
  const patientVisits = () => {
    const state = { id: id }
    startSxpProxy(OPD_PROJECT_ID, radiologyIntents?.getPatientVisits, state)
      .then((data) => {
        const visitResources: { resource: DomainResource }[] =
          data?.data?.entry ?? []
        const patientVisits = formatPatientVisits(
          visitResources?.map((vr) => vr?.resource)
        )
        setVisits(patientVisits)
      })
      .catch((err) => console.log(err))
  }

  const ordered = orders?.filter((order: RadiologyOrders) =>
    order?.radiology_order_tests?.some(
      (test) =>
        test.test_status === radiologyTestStatus?.ordered ||
        test.test_status === radiologyTestStatus?.entered ||
        test?.test_status === radiologyTestStatus?.reOrdered
    )
  )
  const submitted = orders?.filter((order: RadiologyOrders) =>
    order?.radiology_order_tests?.some(
      (test) => test?.test_status === radiologyTestStatus?.submitted
    )
  )
  const completed = orders?.filter(
    (o) =>
      o?.status === radiologyTestStatus?.approved ||
      o?.status === radiologyTestStatus?.completed
  )

  const handleViewOrdered = (id: string) => {
    dispatch(setRadiologyActiveTab(tabs?.testing))
    onView(`${radiologyEndPoint?.results}/${id}`)
  }

  const handleViewSubmitted = (id: string) => {
    dispatch(setRadiologyActiveTab(tabs?.validation))
    onView(`${radiologyEndPoint?.results}/${id}`)
  }
  const handleViewCompleted = (id: string) => {
    onView(`${radiologyEndPoint?.results}/${id}`)
  }
  useEffect(() => {
    patientVisits()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <>
      <RadiologySearchTable
        mode='ordered'
        orders={ordered}
        onOrderView={handleViewOrdered}
        onOrderCreate={() => onCreate(id)}
      />
      <RadiologySearchTable
        mode='tested'
        orders={submitted}
        onOrderView={handleViewSubmitted}
        onOrderCreate={() => onCreate(id)}
      />
      <RadiologySearchTable
        mode='completed'
        orders={completed}
        onOrderView={handleViewCompleted}
      />
      <PatientVisitsTable visits={visits} type={radiologyText} />
    </>
  )
}

export default AllRadiologyOrders
